import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import LuxuryCarWebsite from './App';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import UserLogin from './pages/UserLogin';
import UserRegister from './pages/UserRegister';
import UserProfile from './pages/UserProfile';
import ProductDetails from './pages/ProductDetails';
import ServiceDetails from './pages/ServiceDetails';
import CategoryProducts from './pages/CategoryProducts';
import Checkout from './pages/Checkout';
import ServiceBooking from './pages/ServiceBooking';
import ModificationDetails from './pages/ModificationDetails';
import ModificationBooking from './pages/ModificationBooking';
import CartPage from './pages/CartPage';

const AppRouter = () => {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LuxuryCarWebsite />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/register" element={<UserRegister />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/service/:id" element={<ServiceDetails />} />
            <Route path="/service/:id/book" element={<ServiceBooking />} />
            <Route path="/modification/:id" element={<ModificationDetails />} />
            <Route path="/modification/:id/book" element={<ModificationBooking />} />
            <Route path="/category/:categoryId" element={<CategoryProducts />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
};

export default AppRouter;
